<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card" style="margin: 20px; height: 100%; min-height: 65vh;">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Cuadros de Salida - Financiación de Vivienda</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col" style="text-align: left; margin-bottom: 10px;">
          <button type="button" class="btn btn-secondary" (click)="RegresarCuadrosSalida()">Volver</button>
        </div>
      </div>
      <br>
      <div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="panel1-tab" data-bs-toggle="tab" data-bs-target="#panel1" type="button" role="tab" aria-controls="ic" aria-selected="true">
              <b style="color: black;">Anexos estadísticos</b>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="panel2-tab" data-bs-toggle="tab" data-bs-target="#panel2" type="button" role="tab" aria-controls="icif" aria-selected="false">
              <b style="color: black;">Cuadros de salida</b>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="panel3-tab" data-bs-toggle="tab" data-bs-target="#panel3" type="button" role="tab" aria-controls="icri" aria-selected="false">
              <b style="color: black;">Serie tipo base</b>
            </button>
          </li>
        </ul>
        <div class="tab-content border" id="myTabContent">
          <div class="tab-pane fade show active" id="panel1" role="tabpanel" aria-labelledby="home-tab">
            <div class="row" style="margin-left: 10px; margin-right: 10px; margin-bottom: 10 px;">
              <div class="col-6">
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A1 – Desembolsos creditos de vivienda (valor)', 'AE1')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A1. Desembolsos crédito de vivienda (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A3 –  Desembolsos creditos de vivienda nueva y usada, por entidad financiadora (valor)', 'AE3')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A3. Desembolso créditos de vivienda nueva y usada, por entidad financiadora (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A5 –  Desembolsos creditos de vivienda de interes social (VIS) nueva y usada, por entidad financiadora (valor)', 'AE5')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A5. Desembolsos créditos de vivienda de interés social (VIS) nueva y usada, por entidad financiadora (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A7- Desembolsos creditos de vivienda - VIS nuevas financiadas con o sin subsidio (valor)', 'AE7')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A7. Desembolsos créditos de vivienda - VIS nuevas financiadas con o sin subsidio (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A9- Desembolsos creditos de vivienda nueva y usada (numero)', 'AE9')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A9. Desembolsos créditos de vivienda nueva y usada (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A11- Desembolsos creditos de vivienda VIS y NO VIS (numero)', 'AE11')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A11. Desembolsos créditos de vivienda VIS y NO VIS (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A13- Desembolsos creditos de vivienda diferente de interes social (NO VIS) nueva y usada, por entidad financiadora (numero)', 'AE13')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A13. Desembolsos créditos  de vivienda diferente de interés social (NO VIS) nueva y usada, por entidad financiadora (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A15- Desembolsos creditos de vivienda financiadas por Departamento (valor)', 'AE15')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A15. Desembolsos créditos de vivienda financiadas por Departamento (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A17- Desembolsos de creditos de vivienda usadas por Departamento (valor)', 'AE17')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A17. Desembolsos créditos de vivienda usadas por Departamento (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A19- Desembolsos creditos de vivienda nueva por Departamento (numero)', 'AE19')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A19. Desembolsos créditos de vivienda nueva por Departamento (numero)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A21- Operaciones de credito (valor)', 'AE21')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A21. Operaciones de crédito (valor)</button>
                </div>
              </div>
              <div class="col-6">
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A2 –  Desembolsos creditos de vivienda nueva y usada (valor)', 'AE2')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A2. Desembolsos crédittos de vivienda nueva y usada (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A4 –  Desembolsos creditos de vivienda VIS y NO VIS (valor)', 'AE4')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A4. Desembolsos créditos de vivienda VIS y NO VIS (valor)</button>
                </div>
                <div class="row" style="margin: 5px; padding: auto;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A6 –  Desembolsos creditos de vivienda diferente de interes social (NO VIS) nueva y usada, por entidad financiadora (valor)', 'AE6')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A6. Desembolsos créditos de vivienda diferente de interés social (NO VIS) nueva y usada, por entidad financiadora (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A8- Desembolsos creditos de vivienda (numero)', 'AE8')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A8. Desembolsos créditos de vivienda (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A10- Desembolsos creditos de vivienda nueva y usada, por entidad financiadora (numero)', 'AE10')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A10. Desembolsos créditos de vivienda nueva y usada, por entidad financiadora (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A12- Desembolsos creditos de vivienda de interes social (VIS) nueva y usada, por entidad financiadora (numero)', 'AE12')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A12. Desembolsos créditos de vivienda de interés social (VIS) nueva y usada, por entidad financiadora (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A14- Desembolsos creditos de vivienda de interes social (VIS) nuevas con o sin subsidio (numero)', 'AE14')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A14. Desembolsos créditos de vivienda - VIS nuevas financiadas con o sin subsidio (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A16- Desembolsos creditos de vivienda nueva por Departamento (valor)', 'AE16')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A16. Desembolsos créditos de vivienda nueva por Departamento (valor)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A18- Desembolsos creditos de vivienda por Departamento (numero)', 'AE18')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A18. Desembolsos créditos de vivienda financiadas por Departamento (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A20- Desembolsos creditos de vivienda usada por Departamento (numero)', 'AE20')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A20. Desembolsos créditos de vivienda usadas por Departamento (número)</button>
                </div>
                <div class="row" style="margin: 5px;">
                  <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A22- subrogaciones para creditos individuales (valor)', 'AE22')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                    A22. Subrogaciones para créditos individuales (valor)</button>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="panel2" role="tabpanel" aria-labelledby="profile-tab">
            <div class="col-7" style="margin: auto;">
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A1 - Valor de los créditos desembolsados para compra de vivienda '+trimestreActual+' trimestre', 'CS1')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A1. Valor de los créditos desembolsados para compra de vivienda {{trimestreActual}} trimestre</button>
              </div>
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A2 - Número de créditos desembolsados para compra de vivienda '+trimestreActual+' trimestre', 'CS2')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A2. Número de créditos desembolsados para compra de vivienda {{trimestreActual}} trimestre</button>
              </div>
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A3 - Composición del valor de créditos y números de viviendas financiadas '+trimestreActual+' trimestre', 'CS3')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A3. Composición del valor de créditos y números de viviendas financiadas</button>
              </div>
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A4 - Valor de los desembolsos para compra de VIS, Total nacional '+trimestreActual+' trimestre', 'CS4')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A4. Valor de los desembolsos para compra de VIS, Total nacional {{trimestreActual}} trimestre</button>
              </div>
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A5 - Número de viviendas de interés social financiadas, Total nacional '+trimestreActual+' trimestre', 'CS5')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A5. Número de viviendas de interés social financiadas, Total nacional {{trimestreActual}} trimestre</button>
              </div>
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarDescarga('A6 - Valor de los créditos entregados para la compra de vivienda a contructores e individuales '+trimestreActual+' trimestre', 'CS6')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A6. Valor de los créditos entregados para la compra de vivienda a contructores e individuales {{trimestreActual}} trimestre</button>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="panel3" role="tabpanel" aria-labelledby="contact-tab">
            <div class="col-6" style="margin: auto;">
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarSerie('A1 - Serie - créditos hipotecarios', 'S1')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A1. Serie - créditos hipotecarios</button>
              </div>
              <div class="row" style="margin: 5px;">
                <button type="button" [disabled]="botones" class="btn btn-outline-primary" (click)="iniciarSerie('A2 - Serie - constructores', 'S2')" style="overflow: hidden; white-space: normal; max-width: 100%;">
                  A2. Serie - constructores</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>

<!--Modal Cargando-->
<button class="btn btn-primary btn-sm" #openmodalcargando data-toggle="modal"  data-target="#modal-cargando" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-cargando" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5 *ngIf= "descargaCSoS">Ha decidido descargar este archivo: <b>{{nombreDescarga}}</b></h5>
              <h5 *ngIf= "!descargaCSoS">Ha decidido descargar este archivo: <b>{{nombreDescarga}}</b>&nbsp; <b>{{anioSerie.value}}</b></h5>
              <button type="button" [disabled]="botones" class="close" data-dismiss="modal" aria-label="Close" #closemodacargando style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
              <br>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closeModalCrearAnio data-dismiss="modal" (click)="cancelarDescarga()">Cancelar</button>
        <button *ngIf="botonDescarga" type="button" class="btn btn-primary" (click)="descargarArchivo()">
          <div style="color: white;">Guardar</div>
        </button>
        <button *ngIf="!botonDescarga" type="button" class="btn btn-primary" disabled>
          <div class="row">
            <div class="d-flex align-items-center">
              <div style="color: white; margin-right: 5px;">Guardar </div>
              <div class="spinner-border spinner-border-sm text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!--Modal icoced-->
<button class="btn btn-primary btn-sm" #openmodalicoced data-toggle="modal"  data-target="#modal-icoced" style="visibility: hidden;" data-backdrop="static"  data-keyboard="false">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-icoced" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Por favor ingrese el valor promedio de <b>ICOCED</b> para el periodo <b>{{trimestreActual}}</b> de <b>{{anioActual}}</b> :</h5>
              <button type="button" [disabled]="botones" class="close" data-dismiss="modal" aria-label="Close" #closemodalicoced style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
              <br>
              <form action="">
                <div><input type="text" class="form-control" name="icoced" [formControl]="icoced" oninput="this.value = this.value.replace(/[^0-9,]/g, '')"></div>
              </form>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <!--button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancelarDescarga()">Cancelar</button-->
        <button type="button" class="btn btn-primary" (click)="guardarIcoced()" [disabled]="icoced.hasError('required')">
          <div style="color: white;">Aceptar</div>
        </button>
      </div>
    </div>
  </div>
</div>


<!--Modal serie-->
<button class="btn btn-primary btn-sm" #openmodalserie data-toggle="modal"  data-target="#modal-serie" style="visibility: hidden;" data-backdrop="static" data-keyboard="false">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-serie" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Ha decidido descargar este archivo: <b>{{nombreDescarga}}</b>, ingrese la vigengia a descargar:</h5>
              <button type="button" [disabled]="botones" class="close" data-dismiss="modal" aria-label="Close" #closemodalserie style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
              <br>
              <form action="">
                <div><input type="text" class="form-control" name="anio" [formControl]="anioSerie" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></div>
              </form>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancelarDescarga()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="iniciarDescarga(nombreDescarga, serieDescarga)"  [disabled]="anioSerie.hasError('required')">
          <div style="color: white;">Aceptar</div>
        </button>
      </div>
    </div>
  </div>
</div>
